import request from '@/axios'
/**
 * @Description: 获取行业类型列表
 */
export function selectProjectTypeList() {
    return request({
        method: 'get',
        url: '/api/ProjectManagement/selectProjectTypeList',
    })
}

/**
 * 查询列表数据
 */
export function selectProjectPublishList(data) {
    return request({
        method: 'post',
        url: '/api/ProjectManagement/selectProjectPublishList',
        data,
    })
}